import SMTooltipPopover from './SMTooltipPopover';

export default SMTooltipPopover;
